const intercom = {
  namespaced: true,

  state: {
    intercom_Status: sessionStorage.getItem('intercom_Status'), //通话状态 0-未进入通话状态 1-通话中 2- 通话结束 3-呼叫中
  },

  mutations: {
    setIntercomStatus(state, value) {
        state.intercom_Status = value
        sessionStorage.setItem('intercom_Status', value)
    }
  },
  actions: {
    UpdateintercomStatus({ commit }, status) {
      commit('setIntercomStatus', status)
    },
  }
}

export default intercom



// WEBPACK FOOTER //
// ./src/store/modules/intercom.js